export const Second = 1000;
export const Minute = Second * 60;
export const Hour = Minute * 60;
export const Day = Hour * 24;

export function msToTimeLeft(ms: number) {
    const days = Math.floor(ms / Day);
    const hours = Math.floor((ms % Day) / Hour);
    const minutes = Math.floor((ms % Hour) / Minute);
    const seconds = Math.floor((ms % Minute) / Second);

    const parts: string[] = [];
    parts.push(`${days}d`);
    parts.push(`${hours}h`);
    parts.push(`${minutes}m`);
    parts.push(`${seconds}s`);

    let index = [days, hours, minutes, seconds].findIndex(e => e !== 0);
    if (index === -1) index = parts.length - 1;

    return parts.slice(index, index + 2).join(' ');
}